import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../CookieAuth/auth.service';
import { Permiso } from '../interfaces/permisos';
import { ConfHttpService } from './conf-http.service';

@Injectable({
  providedIn: 'root'
})
export class PermisoService {
  endpopint:string='';

  headers:HttpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  constructor(private http:HttpClient, private cookie: AuthService, conf:ConfHttpService) {
    this.headers= new HttpHeaders({'Content-Type': 'application/json'});
    this.endpopint=conf.getBackend();
  }
  get(id:string){
    return this.http.get<Permiso[]>(this.endpopint+'permiso/'+id);
  }
  getbyid(id:string){
    return this.http.get<Permiso[]>(this.endpopint+'permisoXId/'+id);
  }
  delete(permiso:Permiso){
    this.http.delete(this.endpopint+'permiso/'+permiso.id).toPromise();
    return 'ok';
  }
  post(permiso:Permiso){
    let id= this.http.post<number>(this.endpopint+'et',permiso ,{headers: this.headers}).toPromise()
    return id;
  }


}
